export interface IUserSessionData {
    getToken(): string;
    getColorMode(): string;
    setColorMode(mode: string): void;
    setData(json: any): void;
    clearData(): void;
    getUser(): { id: string | null; role: string | null; userName: string | null; name: string | null; avatarUrl: string | null; }
}

export class UserSessionData implements IUserSessionData {
    static tokenKey = 'apiToken';
    static userIdKey = 'userSession_userId';
    static userRoleKey = 'userSession_userRole';
    static userUserNameKey = 'userSession_userUserName';
    static userNameKey = 'userSession_userName';
    static userAvatarUrlKey = 'userSession_userAvatarUrl';
    static colorModeKey = 'colorMode';

    private readonly data: Map<string, any> = new Map<string, any>();

    private static instance: IUserSessionData;

    private constructor() {
    }

    public static getInstance(): IUserSessionData {
        if (!UserSessionData.instance) {
            UserSessionData.instance = new UserSessionData();
        }

        return UserSessionData.instance;
    }

    setData(json: any): void {
        this.data.set(UserSessionData.tokenKey, json.token);
        this.data.set(UserSessionData.userIdKey, json.user.id);
        this.data.set(UserSessionData.userRoleKey, json.user.role);
        this.data.set(UserSessionData.userUserNameKey, json.user.userName);
        this.data.set(UserSessionData.userNameKey, json.user.name);
        this.data.set(UserSessionData.userAvatarUrlKey, json.user.avatarUrl);

        localStorage.setItem(UserSessionData.tokenKey, json.token);
        localStorage.setItem(UserSessionData.userIdKey, json.user.id);
        localStorage.setItem(UserSessionData.userRoleKey, json.user.role);
        localStorage.setItem(UserSessionData.userUserNameKey, json.user.userName);
        localStorage.setItem(UserSessionData.userNameKey, json.user.name);
        localStorage.setItem(UserSessionData.userAvatarUrlKey, json.user.avatarUrl);
    }

    setColorMode(mode: string): void {
        this.data.set(UserSessionData.colorModeKey, mode);
        localStorage.setItem(UserSessionData.colorModeKey, mode);
    }

    getUser(): { id: string | null; role: string | null; userName: string | null; name: string | null; avatarUrl: string | null; } {
        const user = {
            id: localStorage.getItem(UserSessionData.userIdKey),
            role: localStorage.getItem(UserSessionData.userRoleKey),
            userName: localStorage.getItem(UserSessionData.userUserNameKey),
            name: localStorage.getItem(UserSessionData.userNameKey),
            avatarUrl: localStorage.getItem(UserSessionData.userAvatarUrlKey),
        };
        return user
    }

    getToken(): string {
        return this.getStringValue(UserSessionData.tokenKey);
    }

    getColorMode(): string {
        return this.getStringValue(UserSessionData.colorModeKey);
    }

    getStringValue(valueKey: string): string {
        let res = this.data.get(valueKey);
        if (!res) {
            res = localStorage.getItem(valueKey);
            this.data.set(valueKey, res);
        }
        return res;
    }

    clearData(): void {
        this.data.clear();
        localStorage.removeItem(UserSessionData.tokenKey)
        localStorage.removeItem(UserSessionData.userIdKey)
        localStorage.removeItem(UserSessionData.userRoleKey)
        localStorage.removeItem(UserSessionData.userUserNameKey)
        localStorage.removeItem(UserSessionData.userNameKey)
        localStorage.removeItem(UserSessionData.userAvatarUrlKey)
    }
}